import { render } from "./carcass.vue?vue&type=template&id=07575466&scoped=true"
import script from "./carcass.vue?vue&type=script&lang=js"
export * from "./carcass.vue?vue&type=script&lang=js"

import "./carcass.vue?vue&type=style&index=0&id=07575466&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07575466"]])

export default __exports__